var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_18907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.272 77.9487C205.4 98.5693 204.891 122.302 194.493 142.305C189.371 152.134 181.384 162.407 168.895 170.065C133.872 191.544 106.477 190.477 86.8675 171.046C67.2581 151.614 33.1632 166.686 14.9484 128.274C-3.26647 89.8628 10.2448 37.1251 55.8204 20.2116C101.396 3.29799 102.65 28.2185 131.094 30.1856C152.849 31.6837 182.668 47.1779 196.272 77.9487Z",
    fill: "#F0F4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3949 52.9435C66.4911 51.2413 64.5169 52.0056 63.5087 52.5824C63.3071 51.4288 62.5709 49.4406 60.0575 49.103C57.3096 48.7372 55.0588 51.4148 55.795 55.1474C56.3295 57.8343 58.0458 60.3055 58.9649 61.4544C59.0727 61.595 59.1759 61.717 59.2603 61.8154H59.7292C61.211 61.7545 64.1933 61.4591 66.5755 60.1179C69.872 58.2423 70.4581 54.791 68.3949 52.9435Z",
    fill: "#BF1C1C",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7034 63.5645C57.7034 63.5645 57.5768 63.7942 57.4033 64.1975",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9252 65.5059C56.1749 67.9583 55.6591 72.1598 59.6543 74.7061C69.5298 81.0037 72.8544 66.1483 65.2814 67.4847C60.081 68.4225 65.5815 82.1666 73.7219 79.3953",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.4 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4019 79.1374C74.6082 79.0436 74.8192 78.9404 75.0302 78.8279",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.224 169.897C62.224 169.897 56.6485 173.69 54.4024 173.437C54.1557 173.424 53.9215 173.325 53.7412 173.156C52.2782 171.646 51.1012 168.992 51.1012 168.992C51.1012 168.992 51.7999 168.026 53.9522 170.591L55.3168 169.339L52.5033 166.497C52.5033 166.497 54.0929 165.236 56.7939 166.844C56.7001 166.647 54.9604 162.858 56.2734 157.7L49.7085 151.365L55.5325 146.291L56.0014 145.897C56.0014 145.897 56.3672 146.259 56.9393 146.835C57.5113 147.412 58.3038 148.106 59.1619 148.861C61.2158 150.666 63.7011 152.612 64.789 152.612C66.7491 152.547 62.224 169.897 62.224 169.897Z",
    fill: "#FCD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9146 167.412C57.9146 167.412 54.7353 170.694 54.4024 173.437C54.1557 173.425 53.9215 173.325 53.7412 173.156C52.2782 171.646 51.1012 168.992 51.1012 168.992C51.1012 168.992 51.7999 168.026 53.9522 170.591L55.3168 169.339L52.5033 166.497C52.5033 166.497 54.0929 165.236 56.7939 166.844C56.7001 166.647 54.9604 162.858 56.2734 157.7L49.7085 151.365L55.5325 146.292L56.9393 146.821C57.516 147.365 58.3038 148.092 59.1619 148.847C57.9287 150.652 55.2887 154.39 55.2887 154.39L57.5723 157.485C57.5723 157.485 56.1655 165.287 57.9146 167.412Z",
    fill: "#DDAF95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.224 169.897C62.224 169.897 56.6485 173.69 54.4024 173.437C54.1557 173.424 53.9215 173.325 53.7412 173.156C52.2782 171.646 51.1012 168.992 51.1012 168.992C51.1012 168.992 51.7999 168.026 53.9522 170.591L55.3168 169.339L52.5033 166.497C52.5033 166.497 54.0929 165.236 56.7939 166.844C56.7001 166.647 54.9604 162.858 56.2734 157.7L49.7085 151.365L55.5325 146.291L56.0014 145.897C56.0014 145.897 56.3672 146.259 56.9393 146.835C57.5113 147.412 58.3038 148.106 59.1619 148.861C61.2158 150.666 63.7011 152.612 64.789 152.612C66.7491 152.547 62.224 169.897 62.224 169.897Z",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3354 169.339C55.6445 168.415 56.1446 167.567 56.8032 166.849",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.337 125.734C158.458 127.017 157.394 128.164 156.181 129.138C145.931 137.626 122.297 141.799 122.297 141.799C122.297 141.799 121.505 142.985 120.285 144.674C118.1 147.707 114.522 152.369 111.606 154.704C110.373 155.693 109.261 156.265 108.412 156.11L112.848 172.49L114.832 179.599C114.832 179.599 94.4526 188.508 59.5977 178.323C59.5977 178.323 59.1992 173.775 59.4946 172.804C59.4946 172.757 59.5227 172.71 59.5415 172.659C59.8963 172.013 60.3595 171.432 60.9107 170.942C60.9107 170.942 60.7138 168.016 60.6153 165.039C60.5028 163.14 60.5263 161.236 60.6856 159.341C60.9342 157.841 62.0314 154.211 62.5848 152.429L62.9083 151.393L61.1733 135.15L60.6763 130.461L60.6481 130.217C60.6481 130.184 60.6481 130.146 60.6481 130.099L60.3761 127.591L51.4104 130.329C51.4104 130.329 51.8793 131.38 52.5264 132.852C53.7034 135.548 55.4337 139.651 55.8089 141.293C55.837 141.426 55.8746 141.558 55.9214 141.686C56.7514 144.055 59.9119 146.207 59.9119 146.207L51.4198 156.129L48.911 154.375C48.5899 154.613 48.2513 154.826 47.8982 155.013C46.2476 155.909 42.7869 157.227 38.9887 155.215C37.3427 154.29 35.9134 153.023 34.7965 151.501C28.1378 142.854 25.2399 135.778 26.1824 127.492C27.125 119.206 64.4136 93.6362 71.8131 93.9034L82.8187 96.3325C83.0579 96.1355 83.7003 95.6291 84.1973 95.6525C86.1996 95.7557 86.2512 98.0815 86.2512 98.0815L110.916 102.086C110.916 102.086 113.472 100.806 113.918 100.825C114.24 100.846 114.551 100.948 114.824 101.121C115.097 101.294 115.322 101.532 115.479 101.814C115.479 101.814 121.866 97.9877 123.92 98.8787C130.681 101.795 164.331 118.147 159.337 125.734Z",
    fill: "#2B67C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.6468 166.258C70.8439 169.339 67.0805 171.38 62.9694 172.049C61.6705 172.256 60.531 172.462 59.5322 172.668C59.8871 172.022 60.3502 171.442 60.9015 170.952C60.9015 170.952 60.7045 168.026 60.6061 165.048C63.4993 166.957 68.5449 169.161 73.6468 166.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.5755 152.453L62.8991 151.417L61.1641 135.173C63.7572 138.892 73.0043 151.557 79.377 152.927C86.0403 154.352 68.226 156.88 62.5755 152.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.839 172.513C105.876 171.721 96.0332 169.967 95.0485 166.324C93.5151 160.631 100.976 157.217 111.606 154.727C110.373 155.717 109.261 156.289 108.413 156.134L112.839 172.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.168 129.14C145.917 137.628 122.284 141.801 122.284 141.801C122.284 141.801 121.491 142.987 120.272 144.676C116.795 136.374 116.264 127.132 118.767 118.486C118.767 118.486 120.586 128.334 128.145 130.678C128.145 130.678 122.359 126.369 124.394 115.996C124.394 115.996 126.368 128.188 139.212 131.574C145.444 133.248 151.544 131.429 156.168 129.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.639 130.25L60.3576 127.624L51.3919 130.362C51.3919 130.362 51.8608 131.413 52.5079 132.885C49.0801 132.533 42.5762 135.699 41.4414 132.247C40.0721 128.064 48.4752 129.504 48.4752 129.504L56.4187 124.885C54.9182 118.461 58.7399 113.631 58.7399 113.631L59.4667 118.114C59.8137 109.594 63.1477 104.933 63.1477 104.933C60.3905 111.671 60.4655 128.275 60.639 130.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.9071 146.221L51.415 156.143L48.9062 154.39C48.5851 154.627 48.2465 154.84 47.8934 155.027C46.2428 155.923 42.7821 157.241 38.9839 155.229C41.7365 151.421 47.4245 145.818 54.1816 143.656C52.5228 146.125 51.0284 148.7 49.7081 151.365L51.4525 153.081C51.4525 153.081 55.8041 148.12 59.9071 146.221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.5259 102.518C80.5259 103.394 79.9726 113.303 87.194 115.943C94.4154 118.583 100.821 114.119 100.821 114.119C100.821 114.119 89.7496 124.801 83.0018 119.089C76.2541 113.378 80.5259 102.518 80.5259 102.518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5836 178.342C59.5836 178.342 59.1944 173.794 59.4852 172.828C59.729 172.012 60.8919 170.952 60.8919 170.952C60.8919 170.952 60.2777 161.733 60.6715 159.356C61.0092 157.316 62.8942 151.384 62.8942 151.384L60.3527 127.591L51.3869 130.334C51.3869 130.334 55.2039 138.775 55.7948 141.279C56.3856 143.783 59.9025 146.188 59.9025 146.188L51.4104 156.106L48.9016 154.357C48.9016 154.357 41.4927 160.153 34.8012 151.487C28.1097 142.821 25.2352 135.764 26.173 127.455C27.1109 119.146 64.4135 93.6034 71.8131 93.866L82.8187 96.2997C83.0531 96.1028 83.7002 95.5963 84.1926 95.6198C86.1949 95.7229 86.2465 98.0488 86.2465 98.0488L110.912 102.053C110.912 102.053 113.472 100.773 113.918 100.792C114.239 100.814 114.549 100.917 114.821 101.089C115.093 101.262 115.318 101.5 115.474 101.781C115.474 101.781 121.861 97.9597 123.915 98.846C130.667 101.763 164.312 118.114 159.323 125.701C152.238 136.486 122.278 141.79 122.278 141.79C122.278 141.79 112.314 156.795 108.389 156.101L114.808 179.589",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.261 127.377C144.58 134.852 153.706 133.473 160.847 123.851C160.847 123.851 166.793 116.184 166.371 107.907C165.949 99.631 163.975 72.668 138.208 79.5612C133.964 80.696 124.065 93.9524 123.235 97.5959C122.851 99.2605 118.879 107.734 115.02 116.507",
    fill: "#2B67C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.261 127.377C144.58 134.852 153.706 133.473 160.847 123.851C160.847 123.851 166.793 116.184 166.371 107.907C165.949 99.631 163.975 72.668 138.208 79.5612C133.964 80.696 124.065 93.9524 123.235 97.5959C122.851 99.2605 118.879 107.734 115.02 116.507",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.645 48.165C102.645 48.165 109.857 47.0724 114.865 51.5553C121.2 57.2246 128.313 72.5114 118.185 97.8425C118.185 97.8425 103.221 87.9107 77.6839 94.56C77.6839 94.56 79.8832 88.6188 76.024 69.9136C74.2796 61.4495 78.6687 41.9518 102.645 48.165Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7142 111.732C102.387 113.462 113.725 101.645 113.725 101.645C113.725 101.645 107.925 100.933 107.404 98.2082C105.74 89.6129 112.436 78.9824 112.436 78.9824C112.436 78.9824 86.5233 79.6999 91.0531 85.5473C91.8959 86.6172 92.5856 87.7993 93.1022 89.0595C94.6731 92.9187 93.5712 95.8307 92.7505 96.5623C92.6909 96.6109 92.6265 96.6533 92.5583 96.6889C90.9921 97.4016 84.5538 96.3372 84.5538 96.3372C84.5538 96.3372 81.9747 110.152 91.7142 111.732Z",
    fill: "#FCD3BC",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.054 104.919C110.054 104.919 105.13 106.888 97.9227 106.302L94.6777 107.892",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4421 107.643L91.2076 105.514C91.2076 105.514 85.8901 103.849 84.2441 100.689",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7505 96.5764C100.685 98.6491 104.413 88.4735 104.413 88.4735C104.413 88.4735 98.0634 86.5978 93.1022 89.0925C94.6731 92.9517 93.5852 95.8637 92.7505 96.5764Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.896 73.6415C114.823 62.8047 112.68 49.8015 96.1833 50.88C84.3993 51.6491 84.4978 64.5678 85.2762 68.4271C86.5892 74.9122 84.7088 77.4632 86.7298 82.912C88.1835 86.8275 91.555 91.2072 95.5268 92.8485C97.9699 93.8567 107.859 86.9166 108.591 83.742",
    fill: "#FCD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.896 73.6415C114.823 62.8047 112.68 49.8015 96.1833 50.88C84.3993 51.6491 84.4978 64.5678 85.2762 68.4271C86.5892 74.9122 84.7088 77.4632 86.7298 82.912C88.1835 86.8275 91.555 91.2072 95.5268 92.8485C97.9699 93.8567 107.859 86.9166 108.591 83.742",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1693 70.4482C92.0708 71.6674 91.9254 74.6685 89.3557 76.9006C87.6864 78.3402 91.5128 79.8126 91.5128 79.8126",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4304 66.1482C89.4304 66.1482 85.7916 64.3756 83.3345 67.3017",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5361 65.9091C98.0944 65.1672 100.824 65.2758 103.316 66.2186",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3156 71.0344C99.4281 72.0801 100.132 72.8632 100.886 72.7788C101.641 72.6944 102.162 71.7847 102.049 70.739C101.937 69.6933 101.233 68.9149 100.479 68.9946C99.7235 69.0743 99.2031 69.9887 99.3156 71.0344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6909 83.2591C94.5839 82.8598 97.3579 81.8462 99.8267 80.2861C99.8267 80.2861 100.169 84.8347 96.3614 85.7772C93.44 86.504 92.3099 83.17 92.3099 83.17",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.392 55.0065C102.392 55.0065 101.351 67.8503 112.684 72.5161L117.997 60.1694L109.96 51.2599L97.8572 47.7617C79.7709 48.8918 71.9868 60.1272 82.0264 90.0678C82.0264 90.0818 79.2176 54.4251 102.392 55.0065Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.199 73.0602C110.04 71.6159 113.693 67.9395 114.926 70.2982C117.032 74.3216 115.498 77.801 113.322 79.2077C112.347 79.822 111.109 80.9755 110.242 79.8877",
    fill: "#FCD3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.199 73.0602C110.04 71.6159 113.693 67.9395 114.926 70.2982C117.032 74.3216 115.498 77.801 113.322 79.2077C112.347 79.822 111.109 80.9755 110.242 79.8877",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2771 71.536C88.3943 72.5817 89.0977 73.3648 89.8527 73.2804C90.6077 73.196 91.1282 72.2863 91.0156 71.2406C90.9031 70.1949 90.195 69.4118 89.44 69.4962C88.6851 69.5806 88.1599 70.4669 88.2771 71.536Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4225 69.407C80.2865 70.2745 80.1927 71.1561 80.1411 72.0329",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.516 52.6714C91.3533 52.4322 82.8376 58.2703 80.8213 67.4377",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8794 50.0548C98.8794 50.0548 85.6652 46.9458 80.7134 55.71",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.599 65.3228C110.395 66.457 111.354 67.4681 112.445 68.3238",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.356 51.7664C105.032 55.9638 106.451 60.0069 108.549 63.7051",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.622 91.509C117.388 92.5594 117.111 93.6004 116.802 94.632",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.858 74.0466C119.001 78.8062 118.856 84.7287 117.974 89.7367",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.296 82.3213C115.401 84.1239 115.123 85.9283 114.48 87.6158C113.838 89.3033 112.845 90.8357 111.568 92.1124",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.205 53.2998C111.451 56.3384 113.121 59.5974 115.723 62.3734C118.466 65.2948 121.209 68.6429 121.725 72.76",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.035 50.1392C106.679 50.561 107.27 51.0567 107.798 51.6163",
    stroke: "white",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.226 120.653C150.963 120.709 150.7 120.756 150.429 120.793C143.338 121.806 135.386 115.926 132.703 108.869C130.584 103.293 132.436 96.9674 133.449 94.2618C133.768 93.413 133.998 92.9206 133.998 92.9206C138.274 86.8247 163.136 98.7587 163.427 105.342C163.718 111.926 158.489 119.058 151.226 120.653Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.005 106.233C159.005 106.233 157.598 116.7 150.429 120.793C143.338 121.806 135.386 115.926 132.703 108.869C130.584 103.293 132.436 96.9675 133.449 94.2618C141.828 89.4741 159.005 106.233 159.005 106.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.005 106.233C159.005 106.233 157.598 116.7 150.429 120.793C143.338 121.806 135.386 115.926 132.703 108.869C130.584 103.293 132.436 96.9675 133.449 94.2618C141.828 89.4741 159.005 106.233 159.005 106.233Z",
    fill: "#E7BBA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.005 106.233C159.005 106.233 157.598 116.7 150.429 120.793C143.338 121.806 135.386 115.926 132.703 108.869C130.584 103.293 132.436 96.9675 133.449 94.2618C141.828 89.4741 159.005 106.233 159.005 106.233Z",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.684 111.743C129.684 111.743 137.758 123.335 147.188 124.301C156.618 125.267 162.663 117.323 163.033 111.335",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.145 59.435C125.853 57.4515 130.945 58.1174 132.563 64.3071C134.181 70.4969 140.535 85.5446 140.535 85.5446C140.535 85.5446 165.856 48.3075 170.377 46.8726C174.897 45.4378 173.12 51.8901 167.057 60.8418C167.057 60.8418 172.735 59.843 174.226 60.8418C175.718 61.8406 174.991 67.8756 175.783 69.967C177.115 73.498 174.156 74.2436 174.156 74.2436C175.608 74.2761 177.004 74.8077 178.109 75.7488C179.736 77.2728 178.92 83.5704 179.385 85.3523C179.849 87.1342 176.745 88.6348 176.745 88.6348C176.745 88.6348 184.205 92.7003 182.522 93.7225C179.68 95.4388 178.062 93.6803 178.062 93.6803C178.062 93.6803 166.597 108.076 157.95 111.284C149.303 114.491 132.474 101.746 130.664 94.8058C128.854 87.8657 131.015 88.2924 129.641 76.7429C128.268 65.1934 125.145 59.435 125.145 59.435Z",
    fill: "#FCD3BC",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.061 36.5555L128.719 45.2467C127.536 45.555 126.827 46.7638 127.135 47.9467L142.896 108.41C143.205 109.593 144.413 110.302 145.596 109.993L178.938 101.302C180.121 100.994 180.83 99.7851 180.522 98.6022L164.761 38.1389C164.453 36.9561 163.244 36.2471 162.061 36.5555Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.959 43.5058C142.977 43.5745 142.981 43.646 142.971 43.7163C142.961 43.7865 142.938 43.8542 142.902 43.9154C142.866 43.9765 142.818 44.03 142.762 44.0728C142.705 44.1156 142.64 44.1468 142.572 44.1647C142.503 44.1825 142.432 44.1867 142.361 44.1769C142.291 44.1671 142.223 44.1436 142.162 44.1077C142.101 44.0718 142.048 44.0241 142.005 43.9675C141.962 43.9109 141.931 43.8465 141.913 43.7778C141.894 43.7091 141.889 43.6373 141.898 43.5667C141.907 43.496 141.93 43.4278 141.966 43.3662C142.002 43.3046 142.05 43.2508 142.107 43.208C142.163 43.1651 142.228 43.134 142.297 43.1166C142.437 43.0809 142.584 43.1019 142.708 43.1748C142.832 43.2477 142.922 43.3667 142.959 43.5058Z",
    fill: "#551E31",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.828 41.7144C149.84 41.7575 149.842 41.8025 149.836 41.8466C149.83 41.8907 149.815 41.9332 149.792 41.9715C149.77 42.0099 149.74 42.0434 149.704 42.0701C149.668 42.0968 149.628 42.1162 149.585 42.1271C149.52 42.1434 149.452 42.1403 149.389 42.118C149.326 42.0958 149.271 42.0554 149.231 42.0021C149.191 41.9487 149.168 41.8847 149.165 41.8181C149.161 41.7516 149.177 41.6854 149.211 41.628C149.245 41.5706 149.295 41.5246 149.355 41.4956C149.415 41.4667 149.482 41.4562 149.548 41.4654C149.615 41.4747 149.676 41.5032 149.726 41.5476C149.776 41.5919 149.811 41.6499 149.828 41.7144Z",
    fill: "#551E31",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.187 42.5603L144.161 43.5977C144.081 43.6185 144.032 43.7004 144.053 43.7808L144.074 43.8627C144.095 43.9431 144.177 43.9914 144.257 43.9707L148.283 42.9332C148.363 42.9125 148.412 42.8306 148.391 42.7502L148.37 42.6683C148.349 42.5879 148.267 42.5395 148.187 42.5603Z",
    fill: "#551E31",
    stroke: "#263238",
    strokeWidth: 0.469717,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76 38.765L179.389 98.7306C179.476 99.067 179.426 99.4242 179.251 99.7239C179.075 100.024 178.787 100.241 178.451 100.33L145.538 108.906C145.201 108.993 144.844 108.943 144.544 108.768C144.245 108.592 144.027 108.304 143.939 107.968L128.309 48.0027C128.222 47.6663 128.272 47.3092 128.448 47.0094C128.624 46.7097 128.911 46.4919 129.247 46.4037L136.004 44.6406C136.221 44.5837 136.45 44.5945 136.661 44.6716C136.871 44.7488 137.053 44.8885 137.181 45.072L137.674 45.7707C137.802 45.9542 137.984 46.0939 138.195 46.171C138.405 46.2481 138.634 46.259 138.851 46.2021L153.683 42.3382C153.897 42.2821 154.09 42.1626 154.236 41.9953C154.381 41.8279 154.473 41.6206 154.499 41.4003L154.588 40.5516C154.612 40.3308 154.704 40.1229 154.849 39.9553C154.995 39.7878 155.189 39.6686 155.404 39.6137L162.161 37.8506C162.494 37.7627 162.848 37.8093 163.148 37.9803C163.447 38.1514 163.667 38.4332 163.76 38.765Z",
    fill: "#FFF7F9",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.906 72.4147C167.964 65.3712 164.734 57.1823 157.69 54.1241C150.647 51.0659 142.458 54.2966 139.4 61.34C136.341 68.3834 139.572 76.5724 146.616 79.6306C153.659 82.6888 161.848 79.4581 164.906 72.4147Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_558_18907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.208 60.4981L151.604 71.6538L146.534 68.6522",
    stroke: "#551E31",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.045 97.2994L151.288 102.186C150.752 102.327 150.193 102.361 149.643 102.286C149.094 102.212 148.564 102.029 148.085 101.75C147.606 101.47 147.187 101.099 146.852 100.657C146.516 100.215 146.271 99.7116 146.13 99.1751C145.989 98.6384 145.955 98.0791 146.03 97.5292C146.105 96.9794 146.288 96.4497 146.568 95.9706C146.848 95.4915 147.22 95.0723 147.662 94.7371C148.104 94.4018 148.609 94.1571 149.145 94.0169L167.902 89.1308C168.982 88.8523 170.129 89.0126 171.091 89.5767C172.053 90.1408 172.753 91.0628 173.037 92.1413C173.323 93.222 173.169 94.3721 172.608 95.3391C172.047 96.3062 171.125 97.0112 170.045 97.2994Z",
    fill: "#CDEFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.284 141.82C122.284 141.82 116.591 128.573 119.47 112.508",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.403 156.134C108.403 156.134 96.8959 159.651 95.7424 162.3C94.5889 164.95 100.901 162.718 100.901 162.718",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.479 101.814C115.479 101.814 104.882 112.318 97.7915 115.117",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7553 98.9915C80.7553 98.9915 78.8234 113.172 86.0307 115.849",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3575 127.624C60.3575 127.624 60.3012 109.036 63.9916 103.287",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9791 108.684C58.9791 108.684 57.9428 120.229 60.2734 123.994",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3918 130.367C51.3918 130.367 43.3311 127.591 41.6617 131.033C39.9924 134.475 46.4682 131.422 46.4682 131.422",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2403 142.418C56.2403 142.418 48.325 146.878 47.917 149.429",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1685 130.085C69.1685 130.085 84.3193 152.983 92.6802 150.882",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5177 162.202C79.5177 162.202 67.6399 170.91 65.9189 170.174",
    stroke: "#263238",
    strokeWidth: 0.468921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.709 125.042C163.511 124.385 164.041 123.949 164.214 123.813C164.036 123.968 163.52 124.418 162.709 125.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "matrix(1 0 0 -1 28 175)",
    fill: "#F0F4F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.66064,
    cy: 3.66064,
    r: 3.66064,
    transform: "matrix(1 0 0 -1 19 159.321)",
    fill: "#F0F4F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_18907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 208,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_558_18907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(140.821 59.7932) rotate(-14.3771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationImage);
export default __webpack_public_path__ + "static/media/confirmationImage.dfc2a52dc3df0682cc8bbd01554ac2f1.svg";
export { ForwardRef as ReactComponent };